import { render, staticRenderFns } from "./lnk-form.vue?vue&type=template&id=67e3d86c&"
import script from "./lnk-form.vue?vue&type=script&lang=js&"
export * from "./lnk-form.vue?vue&type=script&lang=js&"
import style0 from "./lnk-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./lnk-form.vue?vue&type=custom&index=0&blockType=lnk-form&ref=lnkFormCom&%3Aform-item=itemData&%3Aform-data=formData&width=500px"
if (typeof block0 === 'function') block0(component)
import block1 from "./lnk-form.vue?vue&type=custom&index=1&blockType=el-button&size=mini&%40click=getChecked"
if (typeof block1 === 'function') block1(component)
import block2 from "./lnk-form.vue?vue&type=custom&index=2&blockType=el-button&size=mini&%40click=true"
if (typeof block2 === 'function') block2(component)

export default component.exports